export default __webpack_public_path__ + "static/media/TotemManual30.cfe2f617.jpg";